(function () {
  var wrap = document.getElementById('sf-wrap');
  var pre  = document.getElementById('sf-preloader');
  var sun  = document.getElementById('sf-sun');
  var ll   = document.getElementById('ll');
  var lr   = document.getElementById('lr');
  var br   = document.getElementById('br');

  function tr(el, props, dur, ease) {
    el.style.transition = Object.keys(props).map(function(p){
      return p + ' ' + dur + 'ms ' + (ease || 'ease');
    }).join(', ');
    requestAnimationFrame(function(){ requestAnimationFrame(function(){
      Object.keys(props).forEach(function(p){ el.style[p] = props[p]; });
    }); });
  }

  setTimeout(function () {
    sun.classList.add('show');
  }, 300);

  setTimeout(function () {
    sun.classList.remove('show');
    sun.classList.add('hide');
  }, 1400);

  setTimeout(function () {
    tr(br, {
      transform : 'translate(-50%,-50%) scale(1)',
      opacity   : '1'
    }, 900, 'cubic-bezier(0.34,1.2,0.64,1)');

    requestAnimationFrame(function(){ requestAnimationFrame(function(){
      var textHalf = (br.scrollWidth / 2) + 16;
      var lineW    = Math.max(20, (window.innerWidth / 2) - textHalf);
      ll.style.marginRight = textHalf + 'px';
      lr.style.marginLeft  = textHalf + 'px';
      ll.style.width = '0px';
      lr.style.width = '0px';
      requestAnimationFrame(function(){
        tr(ll, { width: lineW + 'px' }, 900, 'cubic-bezier(0.77,0,0.18,1)');
        tr(lr, { width: lineW + 'px' }, 900, 'cubic-bezier(0.77,0,0.18,1)');
      });
    }); });
  }, 1800);

  setTimeout(function () {
    tr(br, {
      transform : 'translate(-50%,-50%) scale(5)',
      opacity   : '0'
    }, 700, 'cubic-bezier(0.77,0,0.18,1)');
    tr(ll, { width: '0px' }, 500, 'ease');
    tr(lr, { width: '0px' }, 500, 'ease');
  }, 3600);

  setTimeout(function () {
    pre.style.transition      = 'transform 0.85s cubic-bezier(0.77,0,0.18,1)';
    pre.style.transformOrigin = 'top';
    pre.style.transform       = 'scaleY(0)';
  }, 4300);

  var animDone = false;
  var pageDone = false;

  function tryRemove() {
    if (!animDone || !pageDone) return;
    wrap.style.transition    = 'transform 0.7s cubic-bezier(0.77,0,0.18,1), opacity 0.5s ease';
    wrap.style.transformOrigin = 'center center';
    wrap.style.transform     = 'scale(1.08)';
    wrap.style.opacity       = '0';
    setTimeout(function () { wrap.remove(); }, 700);
  }

  setTimeout(function () { animDone = true; tryRemove(); }, 4000);

  window.addEventListener('load', function () { pageDone = true; tryRemove(); });

})();